<template>
  <div class="gm-admin-tab">
    <server-table
      class="text-center groovemail-hard-bounce-table"
      ref="serverTable"
      :url="hardBounceListingUrl"
      tableRef="hardBounceDataTable"
      :slotData="hardBouncesTableSlotData"
      :tableColumns="hardBounceTableColumns"
      :tableOptions="hardBounceTableOptions"
      tableTitle="frontend_groovemail_admin_hard_bounce_emails"
      addNewBtnText="frontend_groovemail_hardbounce_email"
      uploadFileBtnText="frontend_groovemail_hardbounce_email_via_import"
      :buttonViaImport="safelistEmailButtonViaImport"
      downloadSampleFileBtnText="frontend_groovemail_admin_block_sample_file"
      @downloadSampleFile="downloadSampleForSafeListingEmails"
      @onFileChange="onFileChange"
      @addNewData="openSafelistEmailModal"
      @loaded="hideLoader()"
      @loading="showLoader()"
    >
      <template slot="top-right-content">
        <gs-button variant="outline" @click="openExportEmailsModal()">
          {{ $t('frontend_hard_bounce_export') }}
        </gs-button>
      </template>
    </server-table>

    <gs-named-modal
      id="safeListEmailModal"
      name="safelist-email-modal"
      :title="this.$t('frontend_groovemail_hardbounce_email')"
    >
      <div class="gm-admin-modal__body">
        <gs-field :label="$t('frontend_groovemail_hardbounce_email')">
          <text-area
            variant="base"
            v-model="model.emails"
            :placeholder="$t('frontend_groovemail_hardbounce_email_enter_emails')"
            rows="5"
          />
        </gs-field>
        <p class="gm-admin-tab__note">
          <span class="fa fa-info-circle"></span>
          {{ this.$t('frontend_groovemail_hardbounce_email_note') }}
        </p>
        <div class="gm-admin-modal__footer">
          <gs-button variant="outline" @click="closeSafelistEmailModal()">{{ $t('frontend_cancel') }}</gs-button>
          <gs-button variant="primary" @click="addEmailsToSafelist()">{{ $t('frontend_save') }}</gs-button>
        </div>
      </div>
    </gs-named-modal>

    <gs-named-modal
      id="exportBounceEmailModal"
      name="export-bounce-email-modal"
      :title="this.$t('frontend_groovemail_hardbounce_emails_export')"
      allow-overflow
    >
      <div class="gm-admin-modal__body">
        <gs-field :label="$t('frontend_groovemail_mail_user_list')">
          <treeselect
            class="custom-treeselect category-select-height"
            :multiple="true"
            :defaultOptions="defaultOptions"
            :async="true"
            :load-options="loadUsers"
            :clearOnSelect="true"
            v-model="model.user_id"
            :placeholder="this.$t('frontend_groovemail_mail_hard_bounce_export_modal_select')"
          />
        </gs-field>
        <div class="gm-admin-modal__footer">
          <gs-button variant="outline" @click="closeExportEmailModal()">{{ $t('frontend_cancel') }}</gs-button>
          <gs-button variant="primary" @click="exportUserHardBounceEmails()">{{ $t('frontend_export') }}</gs-button>
        </div>
      </div>
    </gs-named-modal>

    <!-- Confirmation delete modal -->
    <confirm-modal
      :ref="`confirmation-safelistUser`"
      :name="`confirmation-safelistUser`"
      :buttonText="$t('frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="this.$t('frontend_groovemail_admin_safelist_swal_title')"
      @confirm="safelistUser"
      @close="closeSafelistUserdModal"
    />

    <!-- Confirmation import csv -->
    <confirm-modal
      :ref="`confirmation-import-csv`"
      :name="`confirmation-import-csv`"
      :buttonText="$t('frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="this.$t('frontend_groovemail_admin_are_you_sure_delete_hardbounce_email')"
      @confirm="confirmFileChnage"
      @close="closeFileChnageConfirm"
    />
  </div>
</template>

<script>
import {Treeselect,ASYNC_SEARCH} from '@riophae/vue-treeselect';
import axios from 'axios';
import { mapActions } from 'vuex';
import Notify from '@groovepages/gd-ui-kit/notify';
import ServerTable from '@groovepages/gd-ui-kit/components/tables/ServerTable.vue';
import { postData } from '@/utils/apiHelper.js';
import { showRequestErrorAlert } from '@/components/showDialog.js';
import { adminUrls } from '@/utils/urls.js';
import monthsMixin from '@/mixin/monthsMixin.js';
import demoModeValuesMixin from '@/mixin/demoModeValuesMixin.js';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import downloadCsvFile from '@/components/downloadCsvFile';

let self;

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('frontend_groovemail_admin_hard_bounce_emails') };
  },
  mixins: [demoModeValuesMixin, monthsMixin],
  data() {
    return {
      hardBounceListingUrl: adminUrls.blocklistsUrls.hardBounceListing,
      model: {
        emails: '',
        user_id:[]
      },
      confirmTarget: null,
      progress: 0,
      defaultOptions: [],
      defaultusers : [
        {
          id: 0,
          label: this.$t('frontend_groovemail_mail_hard_bounce_all_users'),
        },
        {
          id: 4,
          label: this.$t('frontend_groovemail_mail_hard_bounce_master_account'),
        }
      ],
      safelistedEmails: [],
      hardBounceTableColumns: ['email', 'created_at', 'actions'],
      hardBounceTableOptions: {
        perPage: 10,
        debounce: 1000,
        alwaysShowPerPageSelect: true,
        perPageValues: [10, 25, 50, 100],
        pagination: { chunk: 5 },
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        filterable: ['email'],
        sortable: ['email', 'created_at'],
        headings: {
          email: () =>
            this.$t(
              'frontend_groovemail_components_suppressions_complainers_email_header'
            ),
          created_at: () => this.$t('frontend_groovemail_created_at'),
          actions: () => this.getDataActions(),
        },
        requestFunction(data) {
          const requestParams = { ...data, ascending: 1 - data.ascending };
          const self = this;
          return axios
            .get(self.url, {
              params: requestParams,
            })
            .catch((e) => {
              self.dispatch('error', e);
              self.hideLoader();
            });
        },
        responseAdapter({ data }) {
          if(self.demoMode) {
            const newData = data[0]?.data.map((obj) => ({
              ...obj,
              email: self.basicEmailText,
            }));

            return {
              data: newData,
              count: newData.length,
            };
          }

          return {
            data: data[0].data,
            count: data[0].total,
          };
        },
      },

      confirmFileTarget: null,
    };
  },

  created() {
    self = this;
    this.defaultOptions = this.defaultusers.map(v => {
      return { id: v.id, label: v.label };
    });
  },

  watch: {
    // Used to refresh hard bounce data table when demo mode changes
    demoMode() {
      this.$refs.serverTable.$refs.hardBounceDataTable.refresh();
    },
  },

  components: {
    Treeselect,
    ServerTable,
  },

  methods: {
    ...mapActions('loader', ['LOADING']),

    // show loader
    showLoader() {
      this.LOADING(true);
    },

    // hide loader
    hideLoader (){
      this.LOADING(false);
    },

    simulateAsyncOperation(fn) {
          setTimeout(fn, 2000);
    },
     loadUsers({ action, searchQuery, callback }) {
      this.getUserList(searchQuery);
      if (action === 'ASYNC_SEARCH') {
        this.simulateAsyncOperation(() => {
          const options = this.users.map(udata => ({
            id: udata.id,
            label: udata.email.toLowerCase()
          }));
          callback(null, options);
        });
      }
    },
    /**
     * Fetch users
     * @param {*} searchQuery 
     * @returns 
     */
    getUserList(searchQuery) {
      axios
        .get('/admin/users-query',{
          params: {
            searchquery:searchQuery
          },
        })
        .then((response) => {
          this.users = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },

    /**
     * Returns column heading for total records
     * @returns {string} column heading for total records
     */
    getDataActions() {
      return this.$refs &&
        this.$refs.serverTable &&
        this.$refs.serverTable.$refs.hardBounceDataTable &&
        this.$refs.serverTable.$refs.hardBounceDataTable.count
        ? `${this.$t(
            'frontend_groovemail_admin_blocklists_total_records_label'
          )}: ${this.$refs.serverTable.$refs.hardBounceDataTable.count}`
        : `${this.$t(
            'frontend_groovemail_admin_blocklists_total_records_label'
          )}: 0`;
    },

    // Used to open safelist email modal.
    openSafelistEmailModal() {
      this.$root.$emit('modal-open', 'safelist-email-modal');
      this.model.emails = '';
    },

    // Used to close safelist email modal.
    closeSafelistEmailModal() {
      this.$root.$emit('modal-close', 'safelist-email-modal');
    },
    openExportEmailsModal(){
      this.$root.$emit('modal-open', 'export-bounce-email-modal');
    },
    closeExportEmailModal() {
      this.$root.$emit('modal-close', 'export-bounce-email-modal');
    },
    // Used to add emails to safelist
    async addEmailsToSafelist() {
      if (this.model.emails.trim()) {
        this.safelistedEmails = [];
        const emailData = this.model.emails.trim();
        const splittedEmails = emailData.split('\n');
        for (let i = 0; i < splittedEmails.length; i++) {
          if (splittedEmails[i].trim()) {
            const res = this.isValidEmail(splittedEmails[i].trim());
            if (!res) {
              this.safelistedEmails = [];
              break;
            }
            this.safelistedEmails.push(splittedEmails[i].trim());
          }
        }

        if (!this.safelistedEmails.length) {
          await showRequestErrorAlert(this.$t('frontend_groovemail_enter_valid_email'),)
          return false;
        }

        if (this.safelistedEmails.length > 10) {
          await showRequestErrorAlert(this.$t('frontend_groovemail_hardbounce_email_count_allowed'));
          return false;
        }
      }
      this.$root.$emit('modal-close', 'safelist-email-modal');
      await postData(adminUrls.blocklistsUrls.safeListHardbouncedEmails, {
        emails: this.safelistedEmails,
      });
      this.$refs.serverTable.$refs.hardBounceDataTable.refresh();
      this.safelistedEmails = [];
      this.model.emails = '';
    },

    /**
     * Used to check if a email is valid.
     * @param {string} email contains email data to be checked.
     * @return {boolean} returns true if valid, false if invalid.
     */
    isValidEmail(email) {
      const reg = RegExp(
        /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
      );
      if (reg.test(email) === false) {
        return false;
      }
      return true;
    },

    // Used to upload a list of emails to safelist in csv format.
    async onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;

      // set the file target
      this.confirmFileTarget = files;

      if (!files.length) return;

      // open the modal
      this.$refs[`confirmation-import-csv`].open();
    },
    
    // confirm file change
    async confirmFileChnage() {
      this.$papa.parse(this.confirmFileTarget[0], {
        header: false,
        skipEmptyLines: 'greedy',
        complete: async (results) => {
          if (results.data.length > 50001) {
            await showRequestErrorAlert(this.$t('frontend_groovemail_admin_safelist_hardbounce_import_limit_message'));
            document.getElementById('upload-emails').value = '';
            return;
          }

          const formData = new FormData();
          formData.append('file', this.confirmFileTarget[0]);

          await postData(
            adminUrls.blocklistsUrls.safeListHardbouncedEmailsViaImport,
            formData
          ).then(() => {
            this.$refs.serverTable.$refs.hardBounceDataTable.refresh();
          }).catch((error) => {
            showRequestErrorAlert(error?.response?.data?.error);
          });

          document.getElementById('upload').value = '';
        },
      });
    },

    // close confirm file change
    closeFileChnageConfirm() {
      this.confirmFileTarget = null;
    },

    // Downloads sample data for safelisting emails.
    async downloadSampleForSafeListingEmails() {
      await downloadCsvFile(
        adminUrls.blocklistsUrls.downloadSampleForWhitelistEmails,
        null,
        'email.csv'
      );
    },


    // open safelistUser modal
    async openSafelistUserdModal(target) {
      // set the Confirm target
      this.confirmTarget = target;

      // open the modal
      this.$refs[`confirmation-safelistUser`].open();
    },

    // close safelistUser modal
    closeSafelistUserdModal() {
      // reset the Confirm target
      this.confirmTarget = null;
    },

    // Used to safelist a user.
    async safelistUser() {
      try {
        const resp = await postData(adminUrls.blocklistsUrls.safeListUser, { email: this.confirmTarget});
        if (resp.data.status === 200) {
          Notify.success(resp.data.message);
        }
        this.$refs.serverTable.$refs.hardBounceDataTable.refresh();

      } catch (error) {
        showRequestErrorAlert(error?.response?.data?.error);
      }
    },

    /**
     * Used to export hard bounce emails.
     */
    async exportUserHardBounceEmails(){
      localStorage.setItem('request_id','');
      axios.get('/admin/download-hard-bounce-data', {
        params: {user_ids:this.model.user_id},
      })
        .then((response) => {
          if(response.data && response.data.request_id !== ''){
            localStorage.setItem('request_id',response.data.request_id);
            this.$parent.$parent.$parent.$parent.$refs.importMsg.toggleShow(true);
            this.closeExportEmailModal();
          }else{
            showRequestErrorAlert(this.$t(response.data.message));
          }
        })
        .catch(error => {
          showRequestErrorAlert(error?.response?.data?.error);
        });
      
    }
  },

  computed: {
    // Used to return demoMode value from store.
    demoMode() {
      return this.$store.state.demoMode.isDemoMode;
    },

    // Returns styling for Import safelist file button
    safelistEmailButtonViaImport() {
      return {
        '--import-email-text': this.$t(
          'frontend_groovemail_hardbounce_email_via_import'
        ),
      };
    },

    /**	
     * Returns slot data for hard bounce table.
     * @return {array} details for slot columns for hard bounce table.
    */
    hardBouncesTableSlotData() {
      return [
        {
          slotName: 'created_at',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.created_at
              ? `${new Date(props.row.created_at).getDate()} ${
                  this.months[new Date(props.row.created_at).getMonth()]
                }, ${new Date(props.row.created_at).getFullYear()}`
              : this.$t('frontend_groovemail_not_available');
          },
        },
        {
          slotName: 'actions',
          slotType: 'actions',
          conditions: () => {
            return true;
          },
          classes: () => {
            return {
              outerDiv: '',
              dropdown: '',
              outerSpan: '',
            };
          },
          actionList: [
            {
              id: 0,
              name: () => this.$t('frontend_groovemail_admin_safelist'),
              conditions: () => {
                return true;
              },
              callback: (props) => this.openSafelistUserdModal(props.row.email),
            },
          ],
        },
      ];
    },
  },
};
</script>


<style lang="scss">
.groovemail-hard-bounce-table #gd-server-table-view {
  .VueTables__table th:last-child {
    text-align: right;
  }

  .VueTables__table th:last-child span {
    display: inline-block;
  }

  .w-resize {
    width: 112px;
  }
}

/* Third-party treeselect menu inside the export modal (cannot be restyled from inside). */
.category-select-height .vue-treeselect__menu-container .vue-treeselect__menu {
  max-height: 150px !important;
  text-transform: none !important;
}
</style>
